export type PersonNameValue = {
  firstName: string;
  secondName: string;
  firstSurname: string;
  secondSurname: string;
};

export function emptyPersonName(): PersonNameValue {
  return { firstName: "", secondName: "", firstSurname: "", secondSurname: "" };
}

export function composeDisplayName(p: {
  firstName?: string | null;
  secondName?: string | null;
  firstSurname?: string | null;
  secondSurname?: string | null;
}): string {
  return [p.firstName, p.secondName, p.firstSurname, p.secondSurname]
    .map((x) => x?.trim())
    .filter((x): x is string => !!x)
    .join(" ");
}

export function suggestPersonName(fullName: string): PersonNameValue {
  const words = fullName.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return emptyPersonName();
  if (words.length === 1) {
    return { firstName: words[0]!, secondName: "", firstSurname: "", secondSurname: "" };
  }
  if (words.length === 2) {
    return { firstName: words[0]!, secondName: "", firstSurname: words[1]!, secondSurname: "" };
  }
  if (words.length === 3) {
    return {
      firstName: words[0]!,
      secondName: "",
      firstSurname: words[1]!,
      secondSurname: words[2]!,
    };
  }
  return {
    firstName: words[0]!,
    secondName: words.slice(1, -2).join(" "),
    firstSurname: words[words.length - 2]!,
    secondSurname: words[words.length - 1]!,
  };
}

export function profileFromApi(profile: {
  fullName: string;
  firstName?: string | null;
  secondName?: string | null;
  firstSurname?: string | null;
  secondSurname?: string | null;
  documentType: string;
}): PersonNameValue {
  if (profile.firstName && profile.firstSurname) {
    return {
      firstName: profile.firstName,
      secondName: profile.secondName ?? "",
      firstSurname: profile.firstSurname,
      secondSurname: profile.secondSurname ?? "",
    };
  }
  if (profile.documentType === "NIT") return emptyPersonName();
  return suggestPersonName(profile.fullName);
}
